import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function AuthRouteLayout() {
  const location = useLocation()
  const { t } = useTranslation()

  const getText = () => {
    if (location.pathname.includes('/select-project')) return t('pages.auth.description.slogan2')
    return t('pages.auth.description.slogan')
  }

  return (
    <div className="c-min-h-screen c-px-20 c-gap-8 c-max-h-screen c-flex c-items-center c-justify-center c-bg-gradient-03 c-relative">
      <section className="c-w-[640px]  c-min-h-[640px] c-gap-2 c-px-2 c-flex c-flex-col c-justify-between c-items-center c-z-10">
        <div className="c-flex c-flex-col c-items-center ">
          <img src="/assets/img/logo_with_name.png" alt={t('common.curecall-logo')} width={160} />
          <h1 className="c-m-0 c-whitespace-pre-wrap c-text-3xl c-text-center c-font-bold c-text-primary-1000 ">
            {getText()}
          </h1>
        </div>
        <img src="/assets/img/doctor.svg" alt="" style={{ width: '60%' }} />
      </section>
      <section className="c-min-w-fit  c-py-4 c-z-20  c-max-h-screen  c-overflow-auto [&>*]:c-bg-white [&>*]:c-p-12 [&>*]:c-shadow-lg [&>*]:c-rounded-xl [&>*]:c-w-[640px] [&>*]:c-min-h-[640px]">
        <Outlet />
      </section>
      <section className="c-absolute c--bottom-1 c-w-full">
        <img
          src="/assets/img/waves.svg"
          alt="Logo waves"
          style={{
            width: '100%',
            height: 'auto',
          }}
        />
      </section>
    </div>
  )
}
